import axios from 'axios';
import {BaseResponse} from "../../BaseResponse";
import {EmployeeRegistRequest} from "./employeeRegistration";


export async function putEmployeeRegistration(uid : string, request: EmployeeRegistRequest) {
    const response = await axios.put<BaseResponse<boolean>>(`/basic/employee/${uid}`, request)
    return response.data
}